import useTranslationStore from '@/language/useTranslationStore.ts'

export default function Content() {
    const { t } = useTranslationStore()

    return (
        <>
            <h1 className="text-4xl font-bold tracking-tight text-gray-100">
                404
            </h1>
            <h2 className="text-xl font-medium text-gray-300">
                {t('shared.notFound.title')}
            </h2>
            <p className="px-4 text-sm leading-relaxed text-gray-400">
                {t('shared.notFound.description')}
            </p>
        </>
    )
}
